import React, { useEffect } from "react";
import "./Contact.css";

export default function ContactBTUI() {
  useEffect(() => {
    // Scroll-triggered animations with better performance
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('revealed')) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all animatable elements
    const animatableSelectors = [
      '.contact-section',
      '.contact-card',
      '.contact-file-info span'
    ];

    animatableSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.classList.add('animate-on-scroll');
        observer.observe(element);
      });
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="contact-container">
      <div className="contact-container-outer">
      <div className="contact-container-inner">
        {/* Hero Section */}
        <div className="contact-hero">
        <div className="contact-header-label">
          <span className="char">C</span>
          <span className="char">O</span>
          <span className="char">N</span>
          <span className="char">T</span>
          <span className="char">A</span>
          <span className="char">C</span>
          <span className="char">T</span>
        </div>
        <h1 className="contact-hero-title">
          <span className="word">GET</span>
          <span className="word">IN</span>
          <span className="word">TOUCH</span>
        </h1>
        <div className="contact-hero-description">
          <p>
            HAVE QUESTIONS ABOUT BTUI'26? WANT TO KNOW MORE ABOUT THE COMPETITIONS 
            OR REGISTRATION PROCESS? OUR TEAM IS HERE TO HELP. REACH OUT TO US 
            THROUGH ANY OF THE CHANNELS BELOW AND WE'LL GET BACK TO YOU AS SOON 
            AS POSSIBLE.
          </p>
        </div>
      </div>

      {/* Contact Information Section */}
      <div className="contact-section">
        <div className="section-label">CONTACT INFORMATION</div>
        <div className="contact-grid">
          
          {/* Teacher-In-Charge */}
          <div className="contact-card">
            <div className="contact-number">01</div>
            <h3 className="contact-name">Mr.K.R. Madushan</h3>
            <div className="contact-line"></div>
            <p className="contact-role">Teacher-In-Charge</p>
            <a href="tel:0716684892" className="contact-phone">0716684892</a>
          </div>

          {/* Chairman */}
          <div className="contact-card">
            <div className="contact-number">02</div>
            <h3 className="contact-name">SHASVINTH SRIKANTH</h3>
            <div className="contact-line"></div>
            <p className="contact-role">Chairman</p>
            <a href="tel:+94770443274" className="contact-phone">+94 77 044 3274</a>
          </div>

          {/* Secretary */}
          <div className="contact-card">
            <div className="contact-number">03</div>
            <h3 className="contact-name">NADULA NISITH</h3>
            <div className="contact-line"></div>
            <p className="contact-role">Secretary</p>
            <a href="tel:+94777544817" className="contact-phone">+94 77 754 4817</a>
          </div>

          {/* Treasurer */}
          <div className="contact-card">
            <div className="contact-number">04</div>
            <h3 className="contact-name">AGSHARAN KATHIRKHAMARUBAN</h3>
            <div className="contact-line"></div>
            <p className="contact-role">Treasurer</p>
            <a href="tel:+94777364189" className="contact-phone">+94 77 736 4189</a>
          </div>

        </div>
      </div>

      {/* File Info Footer */}
      <div className="contact-file-info">
        <span>C</span>
        <span>1</span>
        <span>T</span>
        <span>MH</span>
        <span>YVR24_</span>
        <span className="file-number">FILE NUMBER: 213</span>
      </div>
      </div>
    </div>
    </div>
  );
}
